import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { NotificaAttivita } from '../../models/notifica-attivita';
import { NotificaAttivitaResponse } from '../../models/notifica-attivita-response';
import { RefreshHeader } from '../../models/refresh-header';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';
import { AppData } from 'src/app/data-store';

@Component({
  selector: '[notifications]',
  templateUrl: 'notifications.component.html',
  styleUrls: ['./notifications.component.css'],
})

export class NotificationsComponent implements OnInit, OnDestroy {
  numToView: number = 4;
  viewAllNotifiche: string = UrlSettingsCore.URL_NOTIFICHE_UTENTE;
  notifiche: NotificaAttivita[] = [];
  subscriptionNotifiche: Subscription;
  numeroNotificheTotali: number;
  polling: boolean = true;
  @Output() onClick = new EventEmitter();
  constructor(private viewManager: ViewManagerService,
              private operationService: OperationsService) {}

  ngOnInit() {
    this.subscriptionNotifiche = this.viewManager.refreshNotifiche.subscribe(param => this.refreshNotifiche(param));
    if(!AppData.getInstance().notifiche) {
      this.prendiNotifiche();
    } else {
      this.notifichePrese(AppData.getInstance().notifiche);
    }
  }

  private refreshNotifiche(response?: RefreshHeader) {
    if(response && response.param){
      this.notifichePrese(response.param)
    }else{
     this.prendiNotifiche(response ? response.timeOut : false);
    }
  }

  private prendiNotifiche(timeOut: boolean = false) {
    let getNotifications;
    let model = this;
    if (this.polling) {
      this.operationService.prendiNotificheAttivitaPaginate({fromResult: 0}).
        subscribe(response => {
          AppData.getInstance().notifiche = response;
          this.notifichePrese(response);
          if(timeOut){
            this.viewManager._refreshAttivitaCompletare.next({param: null, timeOut: timeOut});
          }
        });
    }
  }

  private notifichePrese(response: NotificaAttivitaResponse) {
    AppData.getInstance().notifiche = response;
    this.notifiche = response.notifiche;
    if (response.numeroNotificheTotali !== null &&
       response.numeroNotificheTotali !== undefined) {
      this.numeroNotificheTotali = response.numeroNotificheTotali;
    }
  }

  ngOnDestroy() {
    this.polling = false;
  }

  getAriaLabel() {
    if(this.notifiche.length > 0) {
      return "Sono presenti " + this.notifiche.length + " " + "notifiche";
    } else {
      return "Non ci sono notifiche ";
    }
  }
}
